import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Port } from '../../entities/port';
import { Route } from '../../entities/route';
import { RouteInformationPage } from '../route-information/route-information';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';

@Component({
  selector: 'page-route-destination-list',
  templateUrl: 'route-destination-list.html',
})
export class RouteDestinationListPage {

    routes: Route[];
    departing: Port;
    route: Route;

    constructor(
        private navCtrl: NavController,
        private navParams: NavParams,
        private spinner: SpinnerDialog,
    ) {
        this.departing = this.navParams.get('port');
        this.routes = this.navParams.get('routes');
    }

    async choseRoute(route: Route) {
        this.route = route;

        this.spinner.show();
        this.navCtrl.push(RouteInformationPage, {
            route: this.route,
        });
        this.spinner.hide();
    }

    isSelected(route: Route): boolean {
        return this.route !== undefined && route.name === this.route.name;
    }

}



// WEBPACK FOOTER //
// ./src/pages/route-destination-list/route-destination-list.ts